import React, { useEffect, createElement } from 'react';
const SCHEMA_ID = 'hirelio-jsonld';
const schema = {
  '@context': 'https://schema.org',
  '@graph': [{
    '@type': ['Organization', 'LocalBusiness', 'ProfessionalService'],
    '@id': 'https://hirelio.com/#organization',
    name: 'Hirelio Career Services',
    description: 'Professional resume writing, ATS optimization, LinkedIn optimization, executive resumes, CV writing, cover letters, career coaching, and interview preparation.',
    slogan: 'Helping Professionals Get Hired Faster.',
    url: 'https://hirelio.com',
    email: 'Hello@hireliocareerservices.com',
    telephone: '+1-800-555-0199',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '100 Career Avenue, Suite 400',
      addressLocality: 'New York',
      addressRegion: 'NY',
      postalCode: '10001',
      addressCountry: 'US'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '10000',
      bestRating: '5'
    },
    review: [{
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Sarah Jenkins'
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5'
      },
      reviewBody: 'Hirelio completely transformed my resume. Within two weeks I had four interviews lined up.'
    }, {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Michael Chen'
      },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5'
      },
      reviewBody: 'The ATS optimization is real. I landed a senior role with a 30% pay bump.'
    }]
  }, {
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'How long does resume writing take?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Our standard turnaround time is 3-5 business days. Executive packages offer a 48-hour turnaround option.'
      }
    }, {
      '@type': 'Question',
      name: 'Is the resume ATS-friendly?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. All resumes are formatted and keyword-optimized to pass modern Applicant Tracking Systems.'
      }
    }, {
      '@type': 'Question',
      name: 'Do I work with a real writer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. You are paired with a certified human resume writer experienced in your industry.'
      }
    }, {
      '@type': 'Question',
      name: 'How many revisions are included?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Professional and Executive packages include unlimited revisions for 14 days. Starter includes 2 rounds.'
      }
    }]
  }]
};
interface SEOProps {
  title: string;
  description?: string;
}
export function SEO({
  title,
  description
}: SEOProps) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    let script = document.getElementById(SCHEMA_ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = SCHEMA_ID;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description]);
  return null;
}